import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'AgentOnCallWarning',
  properties: {
    agentId: prop(String).isRequired,
    reasonId: prop(String).isRequired,
  },
});
